export const textOffsetX = 20;
export const textOffsetY = 10;
export const timeTextOffsetY = 14;
export const textFill = '#FFF';
export const textAnchor = 'middle';
